interface UserLocale {
    displayString: string;
    languageTag: string;
}

interface Locales {
    locales: Array<UserLocale>;
}

export function localeOptions(selectLanguage: string, data: Locales) {
    const options = new Array(0);
    options.push({
        label: selectLanguage,
        disabled: true
    });

    data?.locales.forEach(v =>
        options.push({
            label: v.displayString,
            value: v.languageTag
        })
    );

    return options;
}
